import axios from 'axios';

import getAxiosConfig from '../../helpers/getAxiosConfig';

export default async ({ id, versionId }) => {
  const { data } = await axios(getAxiosConfig('create-enrollment', { id, versionId }));
  return data;
};
